export default {
  '@@functional/placeholder': true
};